var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", [
    _c(
      "div",
      [
        _c(
          "div",
          [
            _c(
              "b-navbar",
              {
                staticClass: "navbar-expand",
                attrs: { toggleable: "lg", type: "dark", variant: "danger" },
              },
              [
                _c(
                  "b-navbar-brand",
                  {
                    attrs: { href: "#/main" },
                    on: { click: _vm.windowReload },
                  },
                  [_vm._v("販売管理(デモ)")]
                ),
                _vm._v(" "),
                _c("b-navbar-toggle", { attrs: { target: "nav-collapse" } }),
                _vm._v("\n             \n        "),
                _c(
                  "b-collapse",
                  { attrs: { id: "nav-collapse", "is-nav": "" } },
                  [
                    _c(
                      "b-navbar-nav",
                      { staticClass: "mr-auto" },
                      [
                        _c(
                          "b-nav-item",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.bottom.v-info",
                                value: _vm.tooltip_matome,
                                expression: "tooltip_matome",
                                modifiers: {
                                  hover: true,
                                  bottom: true,
                                  "v-info": true,
                                },
                              },
                            ],
                            class:
                              _vm.pms_nyukin > 0 ? ["active", "b-nav"] : [],
                            attrs: { disabled: _vm.pms_hanbai == 0 },
                            on: {
                              click: function ($event) {
                                return _vm.menuSelect("matome")
                              },
                            },
                          },
                          [
                            _c("b-icon", { attrs: { icon: "card-checklist" } }),
                            _vm._v("\n              一括\n            "),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.bottom.v-info",
                                value: _vm.tooltip_urikake,
                                expression: "tooltip_urikake",
                                modifiers: {
                                  hover: true,
                                  bottom: true,
                                  "v-info": true,
                                },
                              },
                            ],
                            class:
                              _vm.pms_nyukin > 0 ? ["active", "b-nav"] : [],
                            attrs: { disabled: _vm.pms_nyukin == 0 },
                            on: {
                              click: function ($event) {
                                return _vm.menuSelect("nyukin")
                              },
                            },
                          },
                          [
                            _c("b-icon", { attrs: { icon: "currency-yen" } }),
                            _vm._v("\n              売掛\n            "),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.bottom.v-info",
                                value: _vm.tooltip_zaiko,
                                expression: "tooltip_zaiko",
                                modifiers: {
                                  hover: true,
                                  bottom: true,
                                  "v-info": true,
                                },
                              },
                            ],
                            class: _vm.pms_zaiko > 0 ? ["active", "b-nav"] : [],
                            attrs: { disabled: _vm.pms_zaiko == 0 },
                            on: {
                              click: function ($event) {
                                return _vm.menuSelect("zaiko")
                              },
                            },
                          },
                          [
                            _c("b-icon", {
                              attrs: { icon: "grid3x3-gap-fill" },
                            }),
                            _vm._v("\n              在庫\n            "),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.bottom.v-info",
                                value: _vm.tooltip_siire,
                                expression: "tooltip_siire",
                                modifiers: {
                                  hover: true,
                                  bottom: true,
                                  "v-info": true,
                                },
                              },
                            ],
                            class:
                              _vm.pms_hattyu > 0 ? ["active", "b-nav"] : [],
                            attrs: { disabled: _vm.pms_hattyu == 0 },
                            on: {
                              click: function ($event) {
                                return _vm.menuSelect("hattyu")
                              },
                            },
                          },
                          [
                            _c("b-icon", { attrs: { icon: "truck" } }),
                            _vm._v("\n              仕入\n            "),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.bottom.v-info",
                                value: _vm.tooltip_syuukei,
                                expression: "tooltip_syuukei",
                                modifiers: {
                                  hover: true,
                                  bottom: true,
                                  "v-info": true,
                                },
                              },
                            ],
                            class: _vm.pms_zaiko > 0 ? ["active", "b-nav"] : [],
                            attrs: { disabled: _vm.pms_zaiko == 0 },
                            on: {
                              click: function ($event) {
                                return _vm.menuSelect("total")
                              },
                            },
                          },
                          [
                            _c("b-icon", { attrs: { icon: "calculator" } }),
                            _vm._v("\n              集計\n            "),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item-dropdown",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.bottom.v-info",
                                value: _vm.tooltip_master,
                                expression: "tooltip_master",
                                modifiers: {
                                  hover: true,
                                  bottom: true,
                                  "v-info": true,
                                },
                              },
                            ],
                            class:
                              _vm.pms_master_company > 0 ||
                              _vm.pms_master_hattyu_company > 0 ||
                              _vm.pms_master_hattyu_company > 0 ||
                              _vm.pms_master_item > 0
                                ? ["active", "b-nav"]
                                : [],
                            attrs: {
                              text: "マスタ",
                              disabled:
                                _vm.pms_master_company == 0 &&
                                _vm.pms_master_hattyu_company == 0 &&
                                _vm.pms_master_hattyu_company == 0 &&
                                _vm.pms_master_item == 0,
                            },
                          },
                          [
                            _c(
                              "template",
                              { slot: "button-content" },
                              [
                                _c("b-icon", { attrs: { icon: "stack" } }),
                                _vm._v(" マスタ\n              "),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                attrs: {
                                  disabled: _vm.pms_master_company == 0,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.menuSelect("master_company")
                                  },
                                },
                              },
                              [
                                _c("b-icon", { attrs: { icon: "house" } }),
                                _vm._v(
                                  "\n                自社\n              "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                attrs: {
                                  disabled: _vm.pms_master_hattyu_company == 0,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.menuSelect(
                                      "master_hattyu_company"
                                    )
                                  },
                                },
                              },
                              [
                                _c("b-icon", { attrs: { icon: "bank" } }),
                                _vm._v(
                                  "\n                発注先\n              "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                attrs: {
                                  disabled: _vm.pms_master_client_company == 0,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.menuSelect(
                                      "master_client_company"
                                    )
                                  },
                                },
                              },
                              [
                                _c("b-icon", { attrs: { icon: "bank2" } }),
                                _vm._v(
                                  "\n                顧客\n              "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                attrs: { disabled: _vm.pms_master_item == 0 },
                                on: {
                                  click: function ($event) {
                                    return _vm.menuSelect("master_item")
                                  },
                                },
                              },
                              [
                                _c("b-icon", { attrs: { icon: "box-seam" } }),
                                _vm._v(
                                  "\n                商品\n              "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                attrs: { disabled: _vm.pms_master_item == 0 },
                                on: {
                                  click: function ($event) {
                                    return _vm.menuSelect("master_item_etc")
                                  },
                                },
                              },
                              [
                                _c("b-icon", { attrs: { icon: "asterisk" } }),
                                _vm._v(
                                  "\n                その他\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-navbar-nav",
                      { staticClass: "ml-auto" },
                      [
                        _c(
                          "b-nav-item-dropdown",
                          { class: ["active", "b-nav"], attrs: { right: "" } },
                          [
                            _c(
                              "template",
                              { slot: "button-content" },
                              [
                                _c("b-icon", { attrs: { icon: "person" } }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.user2.name1 +
                                        " " +
                                        (_vm.user2.name2 || "")
                                    ) +
                                    "\n              "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.myPageShow()
                                  },
                                },
                              },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "person-lines-fill" },
                                }),
                                _vm._v(
                                  "\n                マイページ\n              "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.logout()
                                  },
                                },
                              },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "box-arrow-right" },
                                }),
                                _vm._v(
                                  "\n                ログアウト\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            attrs: {
              id: "modal-mypage",
              title: "マイページ ",
              "header-bg-variant": "dark",
              "header-text-variant": "light",
              "body-bg-variant": "light",
              "hide-footer": "",
              centered: "",
            },
          },
          [
            _c(
              "div",
              { staticClass: "modal_div" },
              [
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("ID")]),
                    _vm._v(" "),
                    _c("b-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.user.login_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "login_id", $$v)
                        },
                        expression: "user.login_id",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("姓")]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "170px" },
                      attrs: { type: "text" },
                      model: {
                        value: _vm.user.name1,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "name1", $$v)
                        },
                        expression: "user.name1",
                      },
                    }),
                    _vm._v("\n           \n          "),
                    _c("label", [_vm._v("名")]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "170px" },
                      attrs: { type: "text" },
                      model: {
                        value: _vm.user.name2,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "name2", $$v)
                        },
                        expression: "user.name2",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("セイ")]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "170px" },
                      attrs: { type: "text" },
                      model: {
                        value: _vm.user.name1_kana,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "name1_kana", $$v)
                        },
                        expression: "user.name1_kana",
                      },
                    }),
                    _vm._v("\n           \n          "),
                    _c("label", [_vm._v("メイ")]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "170px" },
                      attrs: { type: "text" },
                      model: {
                        value: _vm.user.name2_kana,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "name2_kana", $$v)
                        },
                        expression: "user.name2_kana",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("TEL")]),
                    _vm._v(" "),
                    _c("b-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.user.tel,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "tel", $$v)
                        },
                        expression: "user.tel",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("eMail")]),
                    _vm._v(" "),
                    _c("b-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.user.mail,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "mail", $$v)
                        },
                        expression: "user.mail",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticStyle: { "margin-left": "350px" },
                    attrs: { variant: "primary" },
                    on: { click: _vm.updateUser },
                  },
                  [
                    _c("b-icon", { attrs: { icon: "save" } }),
                    _vm._v(" 保存\n        "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("パスワード")]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "150px !important" },
                      attrs: { type: "text" },
                      model: {
                        value: _vm.user.password,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "password", $$v)
                        },
                        expression: "user.password",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("パスワード再入力")]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "150px !important" },
                      attrs: { type: "text" },
                      model: {
                        value: _vm.user.password_confirmation,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "password_confirmation", $$v)
                        },
                        expression: "user.password_confirmation",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticStyle: {
                      width: "170px !important",
                      "margin-left": "280px",
                    },
                    attrs: { variant: "primary" },
                    on: { click: _vm.updatePass },
                  },
                  [
                    _c("b-icon", { attrs: { icon: "save" } }),
                    _vm._v(" パスワード変更\n        "),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c(
                  "b-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$bvModal.hide("modal-mypage")
                      },
                    },
                  },
                  [
                    _c("b-icon", { attrs: { icon: "x" } }),
                    _vm._v("取消\n        "),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c("MitumoriDetail", {
          ref: "child_mitumori_detail",
          attrs: { modal_id: "main-mitumori_detail" },
          on: { close_modal: _vm.closeModal },
        }),
        _vm._v(" "),
        _c("Matome", {
          ref: "child_matome",
          attrs: { modal_id: "main-matome" },
          on: { close_modal: _vm.closeModal },
        }),
        _vm._v(" "),
        _c("Jyutyu", {
          ref: "child_jyutyu",
          attrs: { modal_id: "main-jyutyu" },
          on: { close_modal: _vm.closeModal },
        }),
        _vm._v(" "),
        _c("JyutyuDetail", {
          ref: "child_jyutyu_detail",
          attrs: { modal_id: "main-jyutyu_detail" },
          on: { close_modal: _vm.closeModal },
        }),
        _vm._v(" "),
        _c("Nouhin", {
          ref: "child_nouhin",
          attrs: { modal_id: "main-nouhin" },
          on: { close_modal: _vm.closeModal },
        }),
        _vm._v(" "),
        _c("NouhinDetail", {
          ref: "child_nouhin_detail",
          attrs: { modal_id: "main-nouhin_detail" },
          on: { close_modal: _vm.closeModal },
        }),
        _vm._v(" "),
        _c("HenpinDetail", {
          ref: "child_henpin_detail",
          attrs: { modal_id: "main-henpin_detail" },
          on: { close_modal: _vm.closeModal },
        }),
        _vm._v(" "),
        _c("Seikyu", {
          ref: "child_seikyu",
          attrs: { modal_id: "main-seikyu" },
          on: { close_modal: _vm.closeModal },
        }),
        _vm._v(" "),
        _c("SeikyuDetail", {
          ref: "child_seikyu_detail",
          attrs: { modal_id: "main-seikyu_detail" },
          on: { close_modal: _vm.closeModal },
        }),
        _vm._v(" "),
        _c("Nyukin", {
          ref: "child_nyukin",
          attrs: { modal_id: "main-nyukin" },
          on: { close_modal: _vm.closeModal },
        }),
        _vm._v(" "),
        _c("NyukinDetail", {
          ref: "child_nyukin_detail",
          attrs: { modal_id: "main-nyukin_detail" },
          on: { close_modal: _vm.closeModal },
        }),
        _vm._v(" "),
        _c("Zaiko", { ref: "child_zaiko", attrs: { modal_id: "main-zaiko" } }),
        _vm._v(" "),
        _c("Hattyu", {
          ref: "child_hattyu",
          attrs: { modal_id: "main-hattyu" },
          on: { close_modal: _vm.closeModal },
        }),
        _vm._v(" "),
        _c("Total", { ref: "child_total", attrs: { modal_id: "main-total" } }),
        _vm._v(" "),
        _c("MasterCompany", {
          ref: "child_master_company",
          attrs: { modal_id: "main-master_company" },
        }),
        _vm._v(" "),
        _c("MasterHattyuCompany", {
          ref: "child_master_hattyu_company",
          attrs: { modal_id: "main-master_hattyu_company" },
        }),
        _vm._v(" "),
        _c("MasterClientCompany", {
          ref: "child_master_client_company",
          attrs: { modal_id: "main-master_client_company" },
          on: { close_modal: _vm.closeModal },
        }),
        _vm._v(" "),
        _c("MasterItem", {
          ref: "child_master_item",
          attrs: { modal_id: "main-master_item" },
        }),
        _vm._v(" "),
        _c("MasterItemEtc", {
          ref: "child_master_item_etc",
          attrs: { modal_id: "main-master_item_etc" },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }